import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

// Head content and pricing section
const ContentWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 50px;
	margin-bottom: 24px;

	${EmotionBreakpoint('mobile')} {
		flex-direction: column;
		gap: 24px;
		padding: 0 24px;
	}
	${EmotionBreakpoint('tablet')} {
		flex-direction: column;
		gap: 24px;
	}
`;

const OfferSection = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: flex-start;
`;

const MainHeadline = styled.h1`
	font-family: 'Oswald', sans-serif;
	font-weight: 500;
	font-size: 40px;
	line-height: 1.05;
	letter-spacing: -1.2px;
	text-transform: uppercase;
	color: #b1927b;
	margin: 0;
	text-align: left;

	.fox & {
		font-family: 'Roboto', sans-serif;
		font-weight: 900;
		font-size: 34px;
		color: #222;
		text-transform: none;
		letter-spacing: -1.02px;
	}
	.wsj & {
		font-family: 'Escrow Banner Compressed', sans-serif;
		color: #e92440;
		font-weight: 700;
	}
	.npr & {
		font-family: 'Gotham', sans-serif;
		color: #2b2a2f;
	}
	.osw & {
		font-family: 'Neue Aachen Pro', sans-serif;
		color: #2b2a2f;
	}

	${EmotionBreakpoint('mobile')} {
		font-size: 40px;
	}
`;

const Description = styled.p`
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 1.4;
	color: #000;
	margin: 0;
	text-align: left;

	.bold-text {
		font-weight: 700;
	}

	.wsj & {
		font-family: Arial, sans-serif;
	}
`;

const PricingSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;

	${EmotionBreakpoint('mobile')} {
		align-items: flex-start;
		padding: 0;
	}
	${EmotionBreakpoint('tablet')} {
		align-items: flex-start;
		padding: 0;
	}
`;

const PriceRow = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	font-size: 16px;
	letter-spacing: -0.48px;
`;

const PriceLabel = styled.span`
	font-family: 'Roboto', sans-serif;
	font-weight: 700;
	color: ${(props) => (props.highlight ? '#cf004f' : '#000')};
	.wsj & {
		font-family: Arial, sans-serif;
		color: ${(props) => (props.highlight ? '#e92440' : '#000')};
	}
`;

const PriceValue = styled.span`
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	color: #000;
	.wsj & {
		font-family: Arial, sans-serif;
	}
`;

const BannerHeader = ({ mainTitle, description, pricingSummary }) => {
	return (
		<ContentWrapper>
			<OfferSection>
				<MainHeadline>{mainTitle}</MainHeadline>
				<Description
					dangerouslySetInnerHTML={{
						__html: description,
					}}
				></Description>
			</OfferSection>
			<PricingSection>
				<PriceRow>
					<PriceLabel>Regular Price:</PriceLabel>
					<PriceValue>${pricingSummary.listPrice}</PriceValue>
				</PriceRow>
				<PriceRow>
					<PriceLabel highlight>Today's Price:</PriceLabel>
					<PriceValue>${pricingSummary.totalPrice}</PriceValue>
				</PriceRow>
				<PriceRow>
					<PriceLabel highlight>Savings:</PriceLabel>
					<PriceValue>${pricingSummary.totalSavings}</PriceValue>
				</PriceRow>
			</PricingSection>
		</ContentWrapper>
	);
};

export default BannerHeader;
